/**
 * control_v2_spanish-info-modals.js
 * Information Cards Modal Functionality
 * No Liquid dependencies - safe for external JS file
 */

// Function to disable scrolling on the main page and show overlay
function disableScroll() {
  document.body.style.overflow = 'hidden';
  document.getElementById('modalOverlay').style.display = 'block';
}

// Function to enable scrolling on the main page and hide overlay
function enableScroll() {
  document.body.style.overflow = '';
  document.getElementById('modalOverlay').style.display = 'none';
}

document.addEventListener('DOMContentLoaded', function() {
  // Event listeners to open the Information Cards
  document.querySelectorAll('.highlight-link-2').forEach(link => {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      const targetId = this.getAttribute('data-target');
      document.getElementById(targetId).style.display = 'block';
      disableScroll();
    });
  });

  // Event listeners to close the Information Cards
  document.querySelectorAll('.close-button-1, .close-button-2, .close-button-3, .close-button-4').forEach(button => {
    button.addEventListener('click', function () {
      this.closest('.info-card-1, .info-card-2, .info-card-3, .info-card-4').style.display = 'none';
      enableScroll();
    });
  });
  
  // CTA scroll and close functionality
  document.querySelectorAll('.cta-scroll-close').forEach(link => {
    link.addEventListener('click', function(e) {
      const infoCard = this.closest('.info-card-1, .info-card-2, .info-card-3, .info-card-4');
      if (infoCard) {
        infoCard.style.display = 'none';
        document.getElementById('modalOverlay').style.display = 'none';
        enableScroll();
      }
    });
  });
});
